export default __webpack_public_path__ + "static/media/right-ar.7b8160d0.svg";